module.exports = __webpack_public_path__ + "check-tenant.a812fca9bcbf0069e425d9318074e15e.png";